// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Text,
//   VStack,
//   Image,
//   Spinner,
//   Flex,
//   Badge,
//   Button,
//   Input,
//   HStack,
//   Textarea,
//   useToast,
//   NumberInput,
//   NumberInputField,
//   NumberInputStepper,
//   NumberIncrementStepper,
//   NumberDecrementStepper,
//   useDisclosure,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   Switch,
//   FormControl,
//   FormLabel,
//   Tag,
//   TagLabel,
// } from '@chakra-ui/react';
// import { useParams } from 'react-router-dom';
// import { ArrowBackIcon } from '@chakra-ui/icons';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// export default function StoryChaptersPage() {
//   const { storyId } = useParams();
//   const [story, setStory] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [commentText, setCommentText] = useState('');
//   const [chapterAudioFiles, setChapterAudioFiles] = useState({});
//   const [chapterPriceInputs, setChapterPriceInputs] = useState({});
//   const [uploadingChapterId, setUploadingChapterId] = useState(null);
//   const [selectedChapter, setSelectedChapter] = useState(null);
//   const [modalPaid, setModalPaid] = useState(false);
//   const [publishSuccessMsg, setPublishSuccessMsg] = useState('');
//   const [modalPublish, setModalPublish] = useState(false);
//   const { isOpen, onOpen, onClose } = useDisclosure();

//   const toast = useToast();
//   const navigate = useNavigate();
//   const baseUrl = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '');
//   const token = localStorage.getItem('token');

//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };

//   useEffect(() => {
//     fetchStory();
//   }, []);

//   const fetchStory = async () => {
//     try {
//       const res = await axios.get(
//         `${baseUrl}/api/admin/user-stories/${storyId}`,
//         { headers },
//       );

//       if (res.data.success) {
//         setStory(res.data.data);
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChapterAudioSelect = (chapterId, file) => {
//     setChapterAudioFiles((prev) => ({
//       ...prev,
//       [chapterId]: file,
//     }));
//   };

//   const openChapterModal = (chapter) => {
//     if (story?.status !== 'approved') {
//       toast({
//         title: 'Story must be approved first',
//         status: 'warning',
//         duration: 2500,
//         isClosable: true,
//       });
//       return;
//     }
//     setPublishSuccessMsg('');
//     setSelectedChapter(chapter);
//     setChapterPriceInputs((prev) => ({
//       ...prev,
//       [chapter._id]: chapter.diamondPrice || 0,
//     }));
//     setModalPaid(!!chapter.isPaid);
//     setModalPublish(!!chapter.isAudioPublished);
//     onOpen();
//   };

//   const closeChapterModal = () => {
//     setSelectedChapter(null);
//     setModalPaid(false);
//     setModalPublish(false);
//     onClose();
//   };

//   const uploadChapterAudio = async (chapterId) => {
//     if (!chapterAudioFiles[chapterId]) {
//       toast({
//         title: 'Select an audio file first',
//         status: 'warning',
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }

//     const formData = new FormData();
//     formData.append('audioFile', chapterAudioFiles[chapterId]);

//     try {
//       setUploadingChapterId(chapterId);

//       const res = await axios.put(
//         `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/upload-audio`,
//         formData,
//         {
//           headers: {
//             ...headers,
//             'Content-Type': 'multipart/form-data',
//           },
//         },
//       );

//       if (res.data.success) {
//         toast({
//           title: 'Chapter audio uploaded',
//           description: 'Audio file uploaded successfully',
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         setChapterAudioFiles((prev) => ({ ...prev, [chapterId]: null }));
//         await fetchStory();

//         // 🔥 UPDATED CHAPTER STATE AFTER SAVE
//         const updatedStoryRes = await axios.get(
//           `${baseUrl}/api/admin/user-stories/${storyId}`,
//           { headers },
//         );

//         const updatedChapter = updatedStoryRes.data.data.chapters.find(
//           (c) => c._id === chapterId,
//         );

//         setSelectedChapter(updatedChapter);
//         setModalPublish(updatedChapter.isAudioPublished);
//         setModalPaid(updatedChapter.isPaid);
//       }
//     } catch (err) {
//       toast({
//         title: 'Upload failed',
//         description: err.response?.data?.message || err.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//     } finally {
//       setUploadingChapterId(null);
//     }
//   };

//   const toggleChapterPublish = async (chapterId) => {
//     try {
//       setUploadingChapterId(chapterId);
//       const res = await axios.patch(
//         `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-publish`,
//         {},
//         { headers },
//       );

//       if (res.data.success) {
//         toast({
//           title: res.data.message,
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         await fetchStory();
//       }
//     } catch (err) {
//       toast({
//         title: 'Toggle failed',
//         description: err.response?.data?.message || err.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//     } finally {
//       setUploadingChapterId(null);
//     }
//   };

//   const handleChapterPriceChange = (chapterId, value) => {
//     const newValue = Number(value);
//     setChapterPriceInputs((prev) => ({
//       ...prev,
//       [chapterId]: Number.isNaN(newValue) ? 0 : newValue,
//     }));
//   };

//   const setChapterDiamondPrice = async (chapterId) => {
//     const price = Number(chapterPriceInputs[chapterId] ?? 0);
//     if (Number.isNaN(price) || price < 0) {
//       toast({
//         title: 'Invalid price',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }

//     setUploadingChapterId(chapterId);
//     try {
//       const res = await axios.patch(
//         `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/set-price`,
//         { diamondPrice: price },
//         { headers },
//       );

//       if (res.data.success) {
//         toast({
//           title: 'Price set successfully',
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         await fetchStory();
//       }
//     } catch (err) {
//       toast({
//         title: 'Set price failed',
//         description: err.response?.data?.message || err.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//     } finally {
//       setUploadingChapterId(null);
//     }
//   };

//   const toggleChapterPaid = async (chapterId) => {
//     setUploadingChapterId(chapterId);
//     try {
//       const res = await axios.patch(
//         `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-paid`,
//         {},
//         { headers },
//       );

//       if (res.data.success) {
//         toast({
//           title: res.data.message,
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         await fetchStory();
//       }
//     } catch (err) {
//       toast({
//         title: 'Toggle paid failed',
//         description: err.response?.data?.message || err.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//     } finally {
//       setUploadingChapterId(null);
//     }
//   };

//   const saveChapterSettings = async () => {
//     if (!selectedChapter) return;

//     const chapterId = selectedChapter._id;
//     setUploadingChapterId(chapterId);

//     try {
//       const publishStatusChanged =
//         modalPublish !== selectedChapter.isAudioPublished;
//       const paidStatusChanged = modalPaid !== selectedChapter.isPaid;

//       // ✅ STEP 1: Upload Audio + Set Price + Toggle Publish
//       if (chapterAudioFiles[chapterId] || publishStatusChanged) {
//         // Upload audio if selected
//         if (chapterAudioFiles[chapterId]) {
//           const formData = new FormData();
//           formData.append('audioFile', chapterAudioFiles[chapterId]);

//           await axios.put(
//             `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/upload-audio`,
//             formData,
//             {
//               headers: {
//                 ...headers,
//                 'Content-Type': 'multipart/form-data',
//               },
//             },
//           );
//         }

//         // Set diamond price if changed
//         const newPrice = Number(chapterPriceInputs[chapterId] ?? 0);
//         const oldPrice = selectedChapter.diamondPrice ?? 0;

//         if (!Number.isNaN(newPrice) && newPrice !== oldPrice) {
//           await axios.patch(
//             `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/set-price`,
//             { diamondPrice: newPrice },
//             { headers },
//           );
//         }

//         // Toggle publish status if changed
//         if (publishStatusChanged) {
//           await axios.patch(
//             `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-publish`,
//             {},
//             { headers },
//           );
//         }

//         // Refresh chapter data to update UI
//         const updatedStoryRes = await axios.get(
//           `${baseUrl}/api/admin/user-stories/${storyId}`,
//           { headers },
//         );

//         const updatedChapter = updatedStoryRes.data.data.chapters.find(
//           (c) => c._id === chapterId,
//         );

//         setSelectedChapter(updatedChapter);
//         setModalPublish(updatedChapter.isAudioPublished);
//         setChapterAudioFiles((prev) => ({ ...prev, [chapterId]: null }));

//         toast({
//           title: 'Audio published successfully! ✅',
//           description: 'Now you can enable paid access',
//           status: 'success',
//           duration: 4000,
//           isClosable: true,
//         });

//         // ❌ DO NOT CLOSE MODAL - Wait for Step 2
//         return;
//       }

//       // ✅ STEP 2: Toggle Paid Access
//       if (paidStatusChanged) {
//         await axios.patch(
//           `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-paid`,
//           {},
//           { headers },
//         );

//         await fetchStory();

//         toast({
//           title: 'Paid access enabled! 🎉',
//           description: 'Users can now purchase this chapter',
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });

//         // ✅ CLOSE MODAL after paid toggle
//         closeChapterModal();
//         return;
//       }

//       // Nothing to save
//       toast({
//         title: 'No changes',
//         status: 'info',
//         duration: 2000,
//         isClosable: true,
//       });
//     } catch (err) {
//       toast({
//         title: 'Save failed',
//         description: err.response?.data?.message || err.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//     } finally {
//       setUploadingChapterId(null);
//     }
//   };

//   if (loading)
//     return (
//       <Flex justify="center" mt="100px">
//         <Spinner size="xl" />
//       </Flex>
//     );
//   const thStyle = {
//     padding: '16px',
//     textAlign: 'left',
//     fontSize: '14px',
//     fontWeight: '600',
//   };

//   const tdStyle = {
//     padding: '16px',
//     verticalAlign: 'middle',
//   };
//   return (
//     <Box mt={{ base: '100px', md: '120px' }} px={{ base: '20px', md: '40px' }}>
//       {/* HEADER */}
//       <Flex justify="space-between" align="center" mb={10} wrap="wrap" gap={4}>
//         <HStack spacing={4}>
//           <Button
//             leftIcon={<ArrowBackIcon />}
//             variant="outline"
//             borderRadius="full"
//             onClick={() => navigate(-1)}
//           >
//             Back
//           </Button>

//           <Text fontSize="26px" fontWeight="800">
//             {story.title} - Chapters
//           </Text>
//         </HStack>

//         <Badge
//           colorScheme="purple"
//           fontSize="14px"
//           px={4}
//           py={2}
//           borderRadius="full"
//         >
//           {story.chapters.length} Chapters
//         </Badge>
//       </Flex>

//       {/* TABLE CONTAINER */}
//       <Box
//         bg="white"
//         borderRadius="2xl"
//         shadow="lg"
//         overflow="hidden"
//         border="1px solid"
//         borderColor="gray.200"
//       >
//         <Box overflowX="auto">
//           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead style={{ background: '#111827', color: 'white' }}>
//               <tr>
//                 <th style={thStyle}>Chapter</th>
//                 <th style={thStyle}>Image</th>
//                 <th style={thStyle}>Description</th>
//                 <th style={thStyle}>Likes</th>
//                 <th style={thStyle}>Comments</th>
//                 <th style={thStyle}>Audio</th>
//                 <th style={thStyle}>Preview</th>
//               </tr>
//             </thead>

//             <tbody>
//               {story.chapters.map((chapter, index) => (
//                 <tr
//                   key={chapter._id}
//                   style={{
//                     borderBottom: '1px solid #eee',
//                     transition: '0.2s',
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.background = '#f9fafb')
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.background = 'transparent')
//                   }
//                 >
//                   {/* CHAPTER TITLE */}
//                   <td style={tdStyle}>
//                     <VStack align="start" spacing={1}>
//                       <Text fontWeight="700">
//                         {index + 1}. {chapter.title}
//                       </Text>
//                       <Text fontSize="12px" color="gray.500">
//                         Created:{' '}
//                         {new Date(chapter.createdAt).toLocaleDateString()}
//                       </Text>
//                     </VStack>
//                   </td>

//                   {/* IMAGE */}
//                   <td style={tdStyle}>
//                     {chapter.image ? (
//                       <Image
//                         src={`${baseUrl}${chapter.image}`}
//                         boxSize="100px"
//                         objectFit="cover"
//                         borderRadius="lg"
//                         shadow="md"
//                       />
//                     ) : (
//                       <Text fontSize="13px" color="gray.400">
//                         No Image
//                       </Text>
//                     )}
//                   </td>

//                   {/* DESCRIPTION */}
//                   <td style={{ ...tdStyle, maxWidth: '350px' }}>
//                     <Text noOfLines={3} fontSize="14px" color="gray.600">
//                       {chapter.description}
//                     </Text>
//                   </td>

//                   {/* CHAPTER LIKES */}
//                   <td style={tdStyle}>
//                     <Badge
//                       colorScheme="pink"
//                       fontSize="13px"
//                       px={3}
//                       py={1}
//                       borderRadius="full"
//                     >
//                       ❤️ {chapter.likes?.length || 0}
//                     </Badge>
//                   </td>

//                   {/* CHAPTER COMMENTS */}
//                   <td style={tdStyle}>
//                     <Badge
//                       colorScheme="blue"
//                       fontSize="13px"
//                       px={3}
//                       py={1}
//                       borderRadius="full"
//                     >
//                       💬 {chapter.comments?.length || 0}
//                     </Badge>
//                   </td>

//                   <td style={tdStyle}>
//                     <VStack align="stretch" spacing={2}>
//                       {chapter.audioFile ? (
//                         <Tag variant="solid" colorScheme="purple">
//                           <TagLabel>Audio file added</TagLabel>
//                         </Tag>
//                       ) : (
//                         <Tag variant="outline" colorScheme="gray">
//                           <TagLabel>No audio</TagLabel>
//                         </Tag>
//                       )}

//                       {story.status === 'approved' ? (
//                         <Button
//                           size="sm"
//                           colorScheme="teal"
//                           onClick={() => openChapterModal(chapter)}
//                         >
//                           Manage Audio Modal
//                         </Button>
//                       ) : (
//                         <Text fontSize="12px" color="gray.500">
//                           Story not approved yet
//                         </Text>
//                       )}
//                     </VStack>
//                   </td>

//                   <td style={tdStyle}>
//                     {chapter.textFile ? (
//                       <HStack spacing={2}>
//                         <Button
//                           size="sm"
//                           colorScheme="blue"
//                           variant="ghost"
//                           onClick={() =>
//                             window.open(
//                               `${baseUrl}${chapter.textFile}`,
//                               '_blank',
//                             )
//                           }
//                         >
//                           Open Document
//                         </Button>
//                       </HStack>
//                     ) : (
//                       <Text fontSize="12px" color="gray.400">
//                         No File
//                       </Text>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </Box>

//         <Modal isOpen={isOpen} onClose={closeChapterModal} size="lg">
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Chapter Audio Manager</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               {selectedChapter ? (
//                 <VStack spacing={4} align="start">
//                   <Text fontSize="lg" fontWeight="bold">
//                     {selectedChapter.title}
//                   </Text>

//                   <Text>
//                     Published status:{' '}
//                     {selectedChapter.isAudioPublished ? 'Yes' : 'No'}
//                   </Text>

//                   <Text>
//                     Paid access:{' '}
//                     {selectedChapter.isPaid ? 'Enabled' : 'Disabled'}
//                   </Text>

//                   <Text>
//                     Diamond Price: {selectedChapter.diamondPrice ?? 0}
//                   </Text>

//                   <FormControl>
//                     <FormLabel>Upload Audio (new)</FormLabel>
//                     <Input
//                       type="file"
//                       accept="audio/*"
//                       onChange={(e) =>
//                         handleChapterAudioSelect(
//                           selectedChapter._id,
//                           e.target.files?.[0],
//                         )
//                       }
//                     />
//                     <Button
//                       mt={2}
//                       w="full"
//                       colorScheme="blue"
//                       isLoading={uploadingChapterId === selectedChapter._id}
//                       onClick={() => uploadChapterAudio(selectedChapter._id)}
//                     >
//                       Upload Audio
//                     </Button>
//                   </FormControl>

//                   <FormControl>
//                     <FormLabel>Diamond Price</FormLabel>
//                     <NumberInput
//                       min={0}
//                       value={chapterPriceInputs[selectedChapter._id] ?? 0}
//                       onChange={(value) =>
//                         handleChapterPriceChange(selectedChapter._id, value)
//                       }
//                     >
//                       <NumberInputField />
//                       <NumberInputStepper>
//                         <NumberIncrementStepper />
//                         <NumberDecrementStepper />
//                       </NumberInputStepper>
//                     </NumberInput>
//                     <Button
//                       mt={2}
//                       w="full"
//                       colorScheme="yellow"
//                       isLoading={uploadingChapterId === selectedChapter._id}
//                       onClick={() =>
//                         setChapterDiamondPrice(selectedChapter._id)
//                       }
//                     >
//                       Set Diamond Price
//                     </Button>
//                   </FormControl>
//                   {publishSuccessMsg && (
//                     <Box
//                       bg="green.100"
//                       color="green.700"
//                       p={3}
//                       borderRadius="md"
//                       fontSize="14px"
//                       mb={3}
//                     >
//                       {publishSuccessMsg}
//                     </Box>
//                   )}
//                   {selectedChapter.isAudioPublished && (
//                     <FormControl display="flex" alignItems="center">
//                       <FormLabel mb="0">Paid access</FormLabel>
//                       <Switch
//                         isChecked={modalPaid}
//                         onChange={(e) => setModalPaid(e.target.checked)}
//                       />
//                     </FormControl>
//                   )}

//                   <FormControl display="flex" alignItems="center">
//                     <FormLabel mb="0">Publish audio</FormLabel>
//                     <Switch
//                       isChecked={modalPublish}
//                       onChange={(e) => setModalPublish(e.target.checked)}
//                     />
//                   </FormControl>

//                   {selectedChapter.audioFile && (
//                     <FormControl>
//                       <Button
//                         w="full"
//                         variant="outline"
//                         colorScheme="purple"
//                         onClick={() =>
//                           window.open(
//                             `${baseUrl}${selectedChapter.audioFile}`,
//                             '_blank',
//                           )
//                         }
//                       >
//                         Open Audio File
//                       </Button>
//                     </FormControl>
//                   )}
//                 </VStack>
//               ) : (
//                 <Text>No chapter selected</Text>
//               )}
//             </ModalBody>

//             <ModalFooter>
//               <Button
//                 colorScheme="blue"
//                 mr={3}
//                 onClick={saveChapterSettings}
//                 isLoading={uploadingChapterId === selectedChapter?._id}
//               >
//                 Save All
//               </Button>
//               <Button variant="ghost" onClick={closeChapterModal}>
//                 Close
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>
//       </Box>
//     </Box>
//   );
// }

import React, { useEffect, useState } from 'react';
import {
  Box,
  Text,
  VStack,
  Image,
  Spinner,
  Flex,
  Badge,
  Button,
  Input,
  HStack,
  Textarea,
  useToast,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Switch,
  FormControl,
  FormLabel,
  Tag,
  TagLabel,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AudioMixer from 'components/audio/AudioMixer';

export default function StoryChaptersPage() {
  const { storyId } = useParams();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [commentText, setCommentText] = useState('');
  const [chapterAudioFiles, setChapterAudioFiles] = useState({});
  const [chapterPriceInputs, setChapterPriceInputs] = useState({});
  const [uploadingChapterId, setUploadingChapterId] = useState(null);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [modalPaid, setModalPaid] = useState(false);
  const [publishSuccessMsg, setPublishSuccessMsg] = useState('');
  const [modalPublish, setModalPublish] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const toast = useToast();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '');
  const token = localStorage.getItem('token');

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  useEffect(() => {
    fetchStory();
  }, []);

  const fetchStory = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}/api/admin/user-stories/${storyId}`,
        { headers },
      );

      if (res.data.success) {
        setStory(res.data.data);
        return res.data.data; // Return data so it can be used immediately after await
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChapterAudioSelect = (chapterId, file) => {
    setChapterAudioFiles((prev) => ({
      ...prev,
      [chapterId]: file,
    }));
  };

  const openChapterModal = (chapter) => {
    if (story?.status !== 'approved') {
      toast({
        title: 'Story must be approved first',
        status: 'warning',
        duration: 2500,
        isClosable: true,
      });
      return;
    }
    setPublishSuccessMsg('');
    setSelectedChapter(chapter);
    setChapterPriceInputs((prev) => ({
      ...prev,
      [chapter._id]: chapter.diamondPrice || 0,
    }));
    setModalPaid(!!chapter.isPaid);
    setModalPublish(!!chapter.isAudioPublished);
    onOpen();
  };

  const closeChapterModal = () => {
    setSelectedChapter(null);
    setModalPaid(false);
    setModalPublish(false);
    onClose();
  };

  const uploadChapterAudio = async (chapterId) => {
    // 🔥 MANDATORY DIAMOND PRICE CHECK
    const currentPrice = Number(chapterPriceInputs[chapterId] || 0);

    if (currentPrice < 0) {
      toast({
        title: 'Invalid Price',
        description: 'Price cannot be negative.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    if (!chapterAudioFiles[chapterId]) {
      toast({
        title: 'Select an audio file first',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const formData = new FormData();
    formData.append('audioFile', chapterAudioFiles[chapterId]);

    try {
      setUploadingChapterId(chapterId);

      const res = await axios.put(
        `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/upload-audio`,
        formData,
        {
          headers: {
            ...headers,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (res.data.success) {
        toast({
          title: 'Chapter audio uploaded',
          description: 'Audio file uploaded successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setChapterAudioFiles((prev) => ({ ...prev, [chapterId]: null }));

        // 🔥 UPDATE STATE IMMEDIATELY
        const updatedStoryData = await fetchStory();
        if (updatedStoryData) {
          const updatedChapter = updatedStoryData.chapters.find(
            (c) => c._id === chapterId,
          );
          setSelectedChapter(updatedChapter);
        }
      }
    } catch (err) {
      toast({
        title: 'Upload failed',
        description: err.response?.data?.message || err.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setUploadingChapterId(null);
    }
  };

  const toggleChapterPublish = async (chapterId) => {
    try {
      setUploadingChapterId(chapterId);
      const res = await axios.patch(
        `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-publish`,
        {},
        { headers },
      );

      if (res.data.success) {
        toast({
          title: res.data.message,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        await fetchStory();
      }
    } catch (err) {
      toast({
        title: 'Toggle failed',
        description: err.response?.data?.message || err.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setUploadingChapterId(null);
    }
  };

  const handleChapterPriceChange = (chapterId, value) => {
    const newValue = Number(value);
    setChapterPriceInputs((prev) => ({
      ...prev,
      [chapterId]: Number.isNaN(newValue) ? 0 : newValue,
    }));
  };

  const setChapterDiamondPrice = async (chapterId) => {
    const price = Number(chapterPriceInputs[chapterId] ?? 0);
    // 🔥 MANDATORY CHECK
    if (Number.isNaN(price) || price < 0) {
      toast({
        title: 'Invalid price',
        description: 'Diamond price cannot be negative',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setUploadingChapterId(chapterId);
    try {
      const res = await axios.patch(
        `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/set-price`,
        { diamondPrice: price },
        { headers },
      );

      if (res.data.success) {
        toast({
          title: 'Price set successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        // 🔥 UPDATE MODAL UI IMMEDIATELY
        const updatedStoryData = await fetchStory();
        if (updatedStoryData) {
          const updatedChapter = updatedStoryData.chapters.find(
            (c) => c._id === chapterId,
          );
          setSelectedChapter(updatedChapter);
        }
      }
    } catch (err) {
      toast({
        title: 'Set price failed',
        description: err.response?.data?.message || err.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setUploadingChapterId(null);
    }
  };

  const toggleChapterPaid = async (chapterId) => {
    setUploadingChapterId(chapterId);
    try {
      const res = await axios.patch(
        `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-paid`,
        {},
        { headers },
      );

      if (res.data.success) {
        toast({
          title: res.data.message,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        await fetchStory();
      }
    } catch (err) {
      toast({
        title: 'Toggle paid failed',
        description: err.response?.data?.message || err.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setUploadingChapterId(null);
    }
  };

  const saveChapterSettings = async () => {
    if (!selectedChapter) return;

    const chapterId = selectedChapter._id;

    // 🔥 CHECK PRICE BEFORE SAVING ALL
    const price = Number(chapterPriceInputs[chapterId] ?? 0);
    if (price < 0) {
      toast({ title: 'Diamond price cannot be negative', status: 'error' });
      return;
    }

    setUploadingChapterId(chapterId);

    try {
      const publishStatusChanged =
        modalPublish !== selectedChapter.isAudioPublished;
      const paidStatusChanged = modalPaid !== selectedChapter.isPaid;

      // ✅ STEP 1: Upload Audio + Set Price + Toggle Publish
      if (chapterAudioFiles[chapterId] || publishStatusChanged) {
        // Upload audio if selected
        if (chapterAudioFiles[chapterId]) {
          const formData = new FormData();
          formData.append('audioFile', chapterAudioFiles[chapterId]);

          await axios.put(
            `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/upload-audio`,
            formData,
            {
              headers: {
                ...headers,
                'Content-Type': 'multipart/form-data',
              },
            },
          );
        }

        // Set diamond price if changed
        const newPrice = Number(chapterPriceInputs[chapterId] ?? 0);
        const oldPrice = selectedChapter.diamondPrice ?? 0;

        if (!Number.isNaN(newPrice) && newPrice !== oldPrice) {
          await axios.patch(
            `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/set-price`,
            { diamondPrice: newPrice },
            { headers },
          );
        }

        // Toggle publish status if changed
        if (publishStatusChanged) {
          await axios.patch(
            `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-publish`,
            {},
            { headers },
          );
        }

        // Refresh chapter data to update UI
        const updatedStoryRes = await axios.get(
          `${baseUrl}/api/admin/user-stories/${storyId}`,
          { headers },
        );

        const updatedChapter = updatedStoryRes.data.data.chapters.find(
          (c) => c._id === chapterId,
        );

        setSelectedChapter(updatedChapter);
        setModalPublish(updatedChapter.isAudioPublished);
        setChapterAudioFiles((prev) => ({ ...prev, [chapterId]: null }));

        toast({
          title: 'Audio published successfully! ✅',
          description: 'Now you can enable paid access',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });

        // ❌ DO NOT CLOSE MODAL - Wait for Step 2
        return;
      }

      // ✅ STEP 2: Toggle Paid Access
      if (paidStatusChanged) {
        await axios.patch(
          `${baseUrl}/api/admin/story/${storyId}/chapters/${chapterId}/toggle-paid`,
          {},
          { headers },
        );

        await fetchStory();

        toast({
          title: 'Paid access enabled! 🎉',
          description: 'Users can now purchase this chapter',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        // ✅ CLOSE MODAL after paid toggle
        closeChapterModal();
        return;
      }

      // Nothing to save
      toast({
        title: 'No changes',
        status: 'info',
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: 'Save failed',
        description: err.response?.data?.message || err.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setUploadingChapterId(null);
    }
  };

  if (loading)
    return (
      <Flex justify="center" mt="100px">
        <Spinner size="xl" />
      </Flex>
    );
  const thStyle = {
    padding: '16px',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '600',
  };

  const tdStyle = {
    padding: '16px',
    verticalAlign: 'middle',
  };
  return (
    <Box mt={{ base: '100px', md: '120px' }} px={{ base: '20px', md: '40px' }}>
      {/* HEADER */}
      <Flex justify="space-between" align="center" mb={10} wrap="wrap" gap={4}>
        <HStack spacing={4}>
          <Button
            leftIcon={<ArrowBackIcon />}
            variant="outline"
            borderRadius="full"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>

          <Text fontSize="26px" fontWeight="800">
            {story.title} - Chapters
          </Text>
        </HStack>

        <Badge
          colorScheme="purple"
          fontSize="14px"
          px={4}
          py={2}
          borderRadius="full"
        >
          {story.chapters.length} Chapters
        </Badge>
      </Flex>

      {/* TABLE CONTAINER */}
      <Box
        bg="white"
        borderRadius="2xl"
        shadow="lg"
        overflow="hidden"
        border="1px solid"
        borderColor="gray.200"
      >
        <Box overflowX="auto">
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#111827', color: 'white' }}>
              <tr>
                <th style={thStyle}>Chapter</th>
                <th style={thStyle}>Image</th>
                <th style={thStyle}>Description</th>
                <th style={thStyle}>Likes</th>
                <th style={thStyle}>Comments</th>
                <th style={thStyle}>Audio</th>
                <th style={thStyle}>Preview</th>
              </tr>
            </thead>

            <tbody>
              {story.chapters.map((chapter, index) => (
                <tr
                  key={chapter._id}
                  style={{
                    borderBottom: '1px solid #eee',
                    transition: '0.2s',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = '#f9fafb')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = 'transparent')
                  }
                >
                  {/* CHAPTER TITLE */}
                  <td style={tdStyle}>
                    <VStack align="start" spacing={1}>
                      <Text fontWeight="700">
                        {index + 1}. {chapter.title}
                      </Text>
                      <Text fontSize="12px" color="gray.500">
                        Created:{' '}
                        {new Date(chapter.createdAt).toLocaleDateString()}
                      </Text>
                    </VStack>
                  </td>

                  {/* IMAGE */}
                  <td style={tdStyle}>
                    {chapter.image ? (
                      <Image
                        src={`${baseUrl}${chapter.image}`}
                        boxSize="100px"
                        objectFit="cover"
                        borderRadius="lg"
                        shadow="md"
                      />
                    ) : (
                      <Text fontSize="13px" color="gray.400">
                        No Image
                      </Text>
                    )}
                  </td>

                  {/* DESCRIPTION */}
                  <td style={{ ...tdStyle, maxWidth: '350px' }}>
                    <Text noOfLines={3} fontSize="14px" color="gray.600">
                      {chapter.description}
                    </Text>
                  </td>

                  {/* CHAPTER LIKES */}
                  <td style={tdStyle}>
                    <Badge
                      colorScheme="pink"
                      fontSize="13px"
                      px={3}
                      py={1}
                      borderRadius="full"
                    >
                      ❤️ {chapter.likes?.length || 0}
                    </Badge>
                  </td>

                  {/* CHAPTER COMMENTS */}
                  <td style={tdStyle}>
                    <Badge
                      colorScheme="blue"
                      fontSize="13px"
                      px={3}
                      py={1}
                      borderRadius="full"
                    >
                      💬 {chapter.comments?.length || 0}
                    </Badge>
                  </td>

                  <td style={tdStyle}>
                    <VStack align="stretch" spacing={2}>
                      {chapter.audioFile ? (
                        <Tag variant="solid" colorScheme="purple">
                          <TagLabel>Audio file added</TagLabel>
                        </Tag>
                      ) : (
                        <Tag variant="outline" colorScheme="gray">
                          <TagLabel>No audio</TagLabel>
                        </Tag>
                      )}

                      {story.status === 'approved' ? (
                        <Button
                          size="sm"
                          colorScheme="teal"
                          onClick={() => openChapterModal(chapter)}
                        >
                          Manage Audio Modal
                        </Button>
                      ) : (
                        <Text fontSize="12px" color="gray.500">
                          Story not approved yet
                        </Text>
                      )}
                    </VStack>
                  </td>

                  <td style={tdStyle}>
                    {chapter.textFile ? (
                      <HStack spacing={2}>
                        <Button
                          size="sm"
                          colorScheme="blue"
                          variant="ghost"
                          onClick={() =>
                            window.open(
                              `${baseUrl}${chapter.textFile}`,
                              '_blank',
                            )
                          }
                        >
                          Open Document
                        </Button>
                      </HStack>
                    ) : (
                      <Text fontSize="12px" color="gray.400">
                        No File
                      </Text>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>

        <Modal isOpen={isOpen} onClose={closeChapterModal} size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Chapter Audio Manager</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {selectedChapter ? (
                <VStack spacing={4} align="start">
                  <Text fontSize="lg" fontWeight="bold">
                    {selectedChapter.title}
                  </Text>

                  <HStack>
                    <Text fontWeight="600">Audio Status:</Text>
                    <Badge
                      colorScheme={
                        selectedChapter.isAudioPublished ? 'green' : 'orange'
                      }
                    >
                      {selectedChapter.isAudioPublished
                        ? 'Published'
                        : 'Pending Approval'}
                    </Badge>
                  </HStack>

                  {selectedChapter.audioFile && (
                    <Button
                      w="full"
                      colorScheme={
                        selectedChapter.isAudioPublished ? 'red' : 'green'
                      }
                      isLoading={uploadingChapterId === selectedChapter._id}
                      onClick={async () => {
                        await toggleChapterPublish(selectedChapter._id);
                        const updated = await fetchStory();
                        if (updated) {
                          const ch = updated.chapters.find(
                            (c) => c._id === selectedChapter._id,
                          );
                          setSelectedChapter(ch);
                        }
                      }}
                    >
                      {selectedChapter.isAudioPublished
                        ? 'Unpublish Audio'
                        : 'Approve & Publish Audio'}
                    </Button>
                  )}

                  <Text>Paid access: Enabled (Required)</Text>

                  <Text>
                    Diamond Price: {selectedChapter.diamondPrice ?? 0}
                  </Text>

                  <FormControl>
                    <FormLabel>Upload Audio (new)</FormLabel>
                    <AudioMixer
                      title="Generate Mixed Chapter Audio"
                      disabled={uploadingChapterId === selectedChapter._id}
                      onMixedFile={(file) =>
                        handleChapterAudioSelect(selectedChapter._id, file)
                      }
                    />
                    {chapterAudioFiles[selectedChapter._id] && (
                      <Text
                        mt={2}
                        fontSize="sm"
                        color="green.600"
                        fontWeight="600"
                      >
                        Selected audio:{' '}
                        {chapterAudioFiles[selectedChapter._id].name}
                      </Text>
                    )}
                    <Input
                      mt={3}
                      type="file"
                      accept="audio/*"
                      onChange={(e) =>
                        handleChapterAudioSelect(
                          selectedChapter._id,
                          e.target.files?.[0],
                        )
                      }
                    />
                    <Button
                      mt={2}
                      w="full"
                      colorScheme="blue"
                      isLoading={uploadingChapterId === selectedChapter._id}
                      onClick={() => uploadChapterAudio(selectedChapter._id)}
                    >
                      Upload Audio
                    </Button>
                  </FormControl>

                  <FormControl>
                    <FormLabel>Diamond Price (Mandatory)</FormLabel>
                    <NumberInput
                      min={0}
                      value={chapterPriceInputs[selectedChapter._id] ?? 0}
                      onChange={(value) =>
                        handleChapterPriceChange(selectedChapter._id, value)
                      }
                    >
                      <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                    <Button
                      mt={2}
                      w="full"
                      colorScheme="yellow"
                      isLoading={uploadingChapterId === selectedChapter._id}
                      onClick={() =>
                        setChapterDiamondPrice(selectedChapter._id)
                      }
                    >
                      Set Diamond Price
                    </Button>
                  </FormControl>
                  {publishSuccessMsg && (
                    <Box
                      bg="green.100"
                      color="green.700"
                      p={3}
                      borderRadius="md"
                      fontSize="14px"
                      mb={3}
                    >
                      {publishSuccessMsg}
                    </Box>
                  )}

                  {selectedChapter.audioFile && (
                    <FormControl>
                      <Button
                        w="full"
                        variant="outline"
                        colorScheme="purple"
                        onClick={() =>
                          window.open(
                            `${baseUrl}${selectedChapter.audioFile}`,
                            '_blank',
                          )
                        }
                      >
                        Open Audio File
                      </Button>
                    </FormControl>
                  )}
                </VStack>
              ) : (
                <Text>No chapter selected</Text>
              )}
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="blue"
                mr={3}
                onClick={saveChapterSettings}
                isLoading={uploadingChapterId === selectedChapter?._id}
              >
                Save All
              </Button>
              <Button variant="ghost" onClick={closeChapterModal}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </Box>
  );
}
